<mat-card class="ticket-card" appearance="outlined">
  <mat-card-content class="ticket-card">
    <div class="ticket-header">
      <div class="ticket-detail">
        <div class="ticket-subject">{{ ticketInfo.subject }}</div>
        <div class="ticket-status">
          <glxy-badge>{{ ticketInfo.status }}</glxy-badge>
        </div>
      </div>
      <span class="ticket-date">{{ ticketInfo.createdAt }}</span>
      <span class="ticket-channel">{{ ticketInfo.groupName }}</span>
      <span class="ticket-channel">{{ ticketInfo.channel }}</span>
    </div>
    <span *ngIf="isMinView" class="ticket-body">{{ ticketInfo.description | trimDescription: 80 }}</span>
    <span *ngIf="!isMinView" class="ticket-body">{{ ticketInfo.description }}&nbsp;</span>
    <a *ngIf="ticketInfo.description.length > 80 && isMinView" (click)="showMoreLess()">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.ACTIONS.VIEW_MORE' | translate }}
    </a>
    <a *ngIf="ticketInfo.description.length > 80 && !isMinView" (click)="showMoreLess()">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.ACTIONS.VIEW_LESS' | translate }}
    </a>
  </mat-card-content>
  <mat-card-actions align="end" class="ticket-card-bottom">
    <div class="card-actions__secondary">
      <span class="ticket-footer">{{ ticketInfo.requester }}</span>
    </div>
    <div class="card-actions__primary">
      <a
        mat-button
        class="view-link-button"
        color="primary"
        (click)="viewTicketComments(ticketInfo.ticket)"
        target="_blank"
      >
        <span>{{ 'CRM.ASSOCIATION_PANEL.TICKETS.ACTIONS.VIEW' | translate }}</span>
      </a>
    </div>
  </mat-card-actions>
</mat-card>
